import React from "react";
import "./Modal.scss"
import plus from "../assets/plus.svg"
import minus from "../assets/minus.svg"
const UnavailableModal = ({ showUnavailable, onClose, data, selectedTickets, setSelectedTickets, setShowCheckout, setShowUnavailable }) => {
    const calculateTotal = () => {
        let total = 0;
        const quantity = selectedTickets?.Quantity || 0;
        const ticket = data?.Seats?.SeatCharges?.find((t) => t.Type === selectedTickets?.ChargeType);
        if (ticket) {
            total += ticket.Amount * quantity;
        }


        return total;
    };
    const updateTicketQuantity = (ticketId, change) => {
        const current = selectedTickets?.Quantity || 0;
        const newQuantity = Math.max(0, current + change);
        const ticket = data?.Seats?.SeatCharges?.find((t) => t.Type === ticketId);
        const maxQuantity = Math.min(ticket?.Available || 0, ticket?.MaxQuantityPerBooking);
        if (newQuantity === 0) {
            setSelectedTickets(null)
        } else {
            setSelectedTickets(
                {
                    "ChargeType": ticketId,
                    "ChargeTypeDisplayName": ticket?.Name,
                    "Quantity": Math.min(newQuantity, maxQuantity),
                    "Amount": ticket?.Amount
                });
        }
    };
    const getTotalTickets = () => {
        return selectedTickets?.Quantity || 0;
    };
    return (
        <div className="UnavailableModal-overlay" onClick={onClose}>
            <div className="UnavailableModal-box" onClick={(e) => e.stopPropagation()}>
                <div className="UnavailableModal-box-header">
                    {showUnavailable?.Type !== "SUCCESS" ? <div className="UnavailableModal-box-header-left">
                        <div className="UnavailableModal-box-header-left-title">
                            {showUnavailable?.Type} Tickets Just Sold Out!
                        </div>
                        <div className="UnavailableModal-box-header-left-subtitle">
                            Don’t worry, you can still grab other great seats before they’re gone!
                        </div>
                    </div> : <div className="UnavailableModal-box-header-left">
                        <div className="UnavailableModal-box-header-left-title">
                            Tickets Running Out!
                        </div>
                        <div className="UnavailableModal-box-header-left-subtitle">
                            Limited tickets left, get more before they sell out!
                        </div>
                    </div>}
                </div>
                <div className="UnavailableModal-box-container">
                    <div className="Event-Seats">
                        {data?.Seats?.SeatCharges?.map((seat, key) => {
                            return (
                                seat?.Available > 0 && <div key={key} className="Event-Seats-item">
                                    <div
                                        className="Event-Seats-item-header">
                                        <div className="Event-Seats-item-header-left">
                                            <div className="seat-header">{seat?.Name}
                                                {seat.OriginalPrice > seat.Amount && <div className="seat-header-save">Save £ {(seat?.OriginalPrice - seat?.Amount) / 100}</div>}
                                            </div>
                                            <div className="seat-des">{seat.Description}</div>

                                        </div>
                                        <div className="Event-Seats-item-header-right">
                                            <div className="seat-price-cont">
                                                {seat.OriginalPrice > seat.Amount && <div className="seat-price-cont-org"> £ {seat.OriginalPrice / 100}</div>}
                                                <div className="seat-price-cont-amount"> £ {seat.Amount / 100}</div>

                                            </div>
                                            {seat?.Available > 0 && <div className="Event-Seats-item-header-right-counter">
                                                <div

                                                    className={`${selectedTickets?.ChargeType === seat.Type ? "Event-Seats-item-header-right-counter-action" : "Event-Seats-item-header-right-counter-disable"}`}
                                                    onClick={() => {
                                                        if (selectedTickets?.ChargeType === seat.Type) {
                                                            updateTicketQuantity(seat.Type, -1)
                                                        }
                                                    }
                                                    }
                                                ><img alt="" src={minus} /></div>
                                                <div
                                                    className={`Event-Seats-item-header-right-counter-count`}>
                                                    {selectedTickets?.ChargeType === seat.Type ? selectedTickets?.Quantity || 0 : 0}
                                                </div>
                                                <div
                                                    className={`${selectedTickets?.ChargeType === seat.Type || !selectedTickets ? "Event-Seats-item-header-right-counter-action" : "Event-Seats-item-header-right-counter-disable"}`}
                                                    onClick={() => {
                                                        if (!selectedTickets) {
                                                            updateTicketQuantity(seat.Type, 1)
                                                        } else if (selectedTickets?.ChargeType === seat.Type) {
                                                            updateTicketQuantity(seat.Type, 1)
                                                        }
                                                    }
                                                    }><img alt="" src={plus} /></div>

                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="UnavailableModal-box-container-button">
                        <div className="UnavailableModal-box-container-button-close"
                            onClick={onClose}>
                            Back to Event
                        </div>   {getTotalTickets() > 0 && < div className="EventPage-Button"
                            onClick={() => {
                                setShowUnavailable(null)
                                setShowCheckout(true)
                            }}>
                            Buy Now - £{calculateTotal() / 100}
                        </div>}
                    </div>

                </div>
            </div>
        </div >
    )

}
export default UnavailableModal